export default function ErrorPage({
  error: _err,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <div className="min-h-[50vh] flex items-center justify-center">
      <div className="text-center space-y-4">
        <h2 className="text-xl font-semibold text-text-primary">
          Something went wrong
        </h2>
        <p className="text-text-muted">An unexpected error occurred.</p>
        <button
          type="button"
          onClick={reset}
          className="px-4 py-2 bg-brand-primary text-brand-foreground rounded-md hover:opacity-90"
        >
          Try again
        </button>
      </div>
    </div>
  )
}
